import React from "react";
import _ from "lodash";
import { Form, Col, Row } from "react-bootstrap";

import GratuityNomineeDetails from "./NomineeDetails";
import { getRelationShipName } from "../../../../util/onBoardingDataFilters";

const Nominees = ({
  familyMembers = [],
  gratuityNomination = [],
  relationShipList,
  handleOnSelectedNominee,
  handleOnDeleteNominee,
  handleOnChangeGratuityDetails,
  isEPFForm2 = false
}) => {
  const gratuityNomineeIds = _.map(gratuityNomination, "familyMemberId");

  const handleOnSelectedRelationship = ({ target: { value } }) => {
    handleOnSelectedNominee(Number(value));
  };

  const getGratuityNominees = (isSelected = true) => {
    return isSelected
      ? familyMembers.filter(member => gratuityNomineeIds.includes(member.id))
      : familyMembers.filter(member => !gratuityNomineeIds.includes(member.id));
  };

  return (
    <div className="pl-2">
      <Row className="mt-1 pl-3 text-danger">
        *** Note: Atleast one nominee to be selected and Sum of the{" "}
        {isEPFForm2 ? "share" : "proportions"} should be 100.
      </Row>
      <Row className="my-3 font-weight-bold">
        {!isEPFForm2 && <Col sm={1}>Sl. No</Col>}
        <Col sm={isEPFForm2 ? 2 : 3}>Relation with the employee</Col>
        <Col sm={3}>Name of nominee(s)</Col>
        <Col sm={isEPFForm2 ? 2 : 1}>{isEPFForm2 ? "DOB" : "Age"}</Col>
        {isEPFForm2 ? (
          <>
            <Col sm={2}>
              Total amount of Share of accumulations in provident fund to be
              paid to each nominee (%)
            </Col>
            <Col sm={2}>
              If the Nominee is a minor, name & relationship & address of the
              guardian who may receive the amount
            </Col>
          </>
        ) : (
          <Col sm={3}>Proportion by which the gratuity will be shared (%)</Col>
        )}
        <Col sm={1} />
      </Row>
      {getGratuityNominees().map((memberDetails, index) => (
        <GratuityNomineeDetails
          gratuityNomination={gratuityNomination}
          handleOnChangeGratuityDetails={handleOnChangeGratuityDetails}
          handleOnDeleteNominee={handleOnDeleteNominee}
          index={index}
          isEPFForm2={isEPFForm2}
          memberDetails={memberDetails}
          relationShipList={relationShipList}
        />
      ))}
      <Form.Group as={Row} controlId={`nominee`}>
        {!isEPFForm2 && <Col sm={1} />}
        <Col sm={isEPFForm2 ? 2 : 3}>
          <Form.Control
            size="sm"
            required
            as="select"
            name="addRelationShip"
            onChange={handleOnSelectedRelationship}
            value="0"
          >
            <option value="0">Choose..</option>
            {getGratuityNominees(false).map(relation => (
              <option value={relation.id}>
                {getRelationShipName(
                  relation.relationShipType,
                  relationShipList
                )}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col sm={3}>
          <Form.Control
            size="sm"
            required
            type="text"
            placeholder="Nominee Name"
            disabled
          />
        </Col>
        <Col sm={isEPFForm2 ? 2 : 1}>
          <Form.Control
            size="sm"
            required
            type="text"
            placeholder={isEPFForm2 ? "DOB of the Nominee" : "Age"}
            disabled
          />
        </Col>
        {isEPFForm2 ? (
          <>
            <Col sm={2}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="totalAmountOfShare1"
                placeholder="Share in %"
                disabled
              />
            </Col>
            <Col sm={2}>
              <Form.Control
                size="sm"
                required
                type="text"
                name="addressOfGuardian"
                placeholder="Guardian Name, Relation and Address"
                disabled
              />
            </Col>
          </>
        ) : (
          <Col sm={3}>
            <Form.Control
              size="sm"
              required
              type="text"
              placeholder="Gratuity Proportion"
              disabled
            />
          </Col>
        )}
        <Col sm={1} />
      </Form.Group>
    </div>
  );
};
export default Nominees;
